import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "saved-to-spend-balance" };
const _hoisted_2 = { class: "top-card" };
const _hoisted_3 = { class: "main-content" };
const _hoisted_4 = { class: "header-section" };
const _hoisted_5 = { class: "title" };
const _hoisted_6 = { class: "balance-row" };
const _hoisted_7 = ["src"];
const _hoisted_8 = { class: "balance" };
const _hoisted_9 = { class: "description-section" };
const _hoisted_10 = { class: "description" };
const _hoisted_11 = ["src"];
const _hoisted_12 = { class: "stat-cards" };
import { computed } from 'vue';
import SavedToSpendStatCard from './SavedToSpendStatCard.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SavedToSpendBalance',
    props: {
        title: { default: 'Your Saved to Spend pot' },
        balance: { default: 0 },
        description: { default: 'The cashback you have earned through buying vouchers will show here. you earn rewards when spending from your pot too!' },
        buttonText: { default: 'Shop' },
        stat1Label: { default: 'Saved in the\nlast year' },
        stat1Value: { default: 0 },
        stat2Label: { default: 'All time\nsavings' },
        stat2Value: { default: 0 },
        stat3Label: { default: 'Average\nreward' },
        stat3Value: { default: '0%' },
        formatter: { default: () => ({ format: (v) => '£' + v.toLocaleString() }) }
    },
    emits: ["shop-click"],
    setup(__props) {
        const props = __props;
        const formattedBalance = computed(() => props.formatter.format(props.balance));
        const formattedStat1 = computed(() => props.formatter.format(props.stat1Value));
        const formattedStat2 = computed(() => props.formatter.format(props.stat2Value));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.title), 1),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("img", {
                                    src: require('@/assets/icons/coins-swap.png'),
                                    alt: "coins",
                                    class: "balance-icon"
                                }, null, 8, _hoisted_7),
                                _createElementVNode("p", _hoisted_8, _toDisplayString(formattedBalance.value), 1)
                            ])
                        ]),
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.description), 1),
                            _createElementVNode("button", {
                                class: "shop-button",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('shop-click')))
                            }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.buttonText), 1),
                                _createElementVNode("img", {
                                    src: require('@/assets/arrow-right.png'),
                                    alt: "arrow",
                                    class: "arrow-icon"
                                }, null, 8, _hoisted_11)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createVNode(SavedToSpendStatCard, {
                        icon: require('@/assets/icons/coins-stacked.png'),
                        label: _ctx.stat1Label,
                        value: formattedStat1.value,
                        variant: "gold"
                    }, null, 8, ["icon", "label", "value"]),
                    _createVNode(SavedToSpendStatCard, {
                        icon: require('@/assets/icons/shopping-bag.png'),
                        label: _ctx.stat2Label,
                        value: formattedStat2.value,
                        variant: "blue"
                    }, null, 8, ["icon", "label", "value"]),
                    _createVNode(SavedToSpendStatCard, {
                        icon: require('@/assets/icons/credit-card-plus.png'),
                        label: _ctx.stat3Label,
                        value: _ctx.stat3Value,
                        variant: "purple"
                    }, null, 8, ["icon", "label", "value"])
                ])
            ]));
        };
    }
});
